var isKeyframesTarget=function isKeyframesTarget(v){return Array.isArray(v);};export{isKeyframesTarget};